import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'input-component', templateUrl: './input.component.html', styleUrls: ['./input.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputComponent {
    @Input() buttonHasFunction: boolean = false;
    @Input() control: FormControl = new FormControl();
    @Input() hasButton: boolean = false;
    @Input() hasCurrencyMask: boolean = false;
    @Input() icon: 'currency' | 'percentage' = null;
    @Input() label: string = '';
    @Input() mask: string = null;
    @Input() minValue: number = null;
    @Input() maxLength: number = 100;
    @Input() maxValue: number = null;
    @Input() placeholder: string = 'elemento.generico-input.placeholder-simplified';
    @Input() type: 'text' | 'number' = 'text';

    @Output() onButtonClick: EventEmitter<any> | null = new EventEmitter<any>();

    buttonFunction() {
        if (!this.buttonHasFunction)
            return;

        this.onButtonClick.emit()
    }
}
